<template>
  <OmtLayoutContainer
    class="hub-home"
    :minHeight="['calc(100vh - 80px)', 'calc(100vh - 104px)']"
    alignContent="flex-start"
  >
    <OmtRow :display="['none', 'flex']">
      <HubBreadcrumb :items="breadcrumb" />
    </OmtRow>
    <OmtRow>
      <section class="hub-home__hero">
        <OmtTypography
          as="h1-bold"
          class="hub-home__title"
          >{{ copy.title }}</OmtTypography
        >
        <OmtTypography
          as="p1"
          class="hub-home__subtitle"
          >{{ copy.subtitle }}</OmtTypography
        >
      </section>
    </OmtRow>
    <OmtRow>
      <div class="hub-home__grid">
        <HubFeaturedCard
          :eyebrow="featured.eyebrow"
          :badge="featured.badge"
          :title="featured.title"
          :description="featured.description"
          :cta-label="featured.ctaLabel"
          :image="featured.image"
          @click="goTo(featured.route)"
        />
        <HubOptionCard
          v-for="option in options"
          :key="option.id"
          variant="banner"
          :title="option.title"
          :description="option.description"
          :image="option.image"
          :image-mobile="option.imageMobile"
          :icon="option.icon"
          :is-new="option.isNew"
          @click="goTo(option.route)"
        />
      </div>
    </OmtRow>
  </OmtLayoutContainer>
</template>

<script>
import HubBreadcrumb from "@/components/Organisms/HubSaude/HubBreadcrumb.vue";
import HubFeaturedCard from "@/components/Organisms/HubSaude/HubFeaturedCard.vue";
import HubOptionCard from "@/components/Organisms/HubSaude/HubOptionCard.vue";
import { HUB_SAUDE_COPY, hubFeaturedCard, hubOptions } from "@/data/hubSaude";

export default {
  name: "HubSaudeHome",
  components: { HubBreadcrumb, HubFeaturedCard, HubOptionCard },
  data() {
    return {
      copy: HUB_SAUDE_COPY,
      featured: hubFeaturedCard,
      options: hubOptions,
      breadcrumb: [{ label: "Home", to: "/" }, { label: "Hub de saúde" }]
    };
  },
  methods: {
    goTo(route) {
      if (route) this.$router.push(route);
    }
  }
};
</script>

<style scoped>
.hub-home {
  width: 100%;
  min-height: calc(100vh - 80px);
  align-content: start;
}

.hub-home__hero {
  margin: -24px -16px 16px;
  padding: 8px 16px 24px;
  background: var(--colors-light-primary-navy-blue);
  color: #fff;
  width: calc(100% + 32px);
}

.hub-home__title,
.hub-home__subtitle {
  color: #fff !important;
  margin: 0;
}

.hub-home__subtitle {
  margin-top: 8px;
  opacity: 0.92;
}

.hub-home__grid {
  display: grid;
  gap: 12px;
  width: 100%;
  overflow: visible;
  align-items: stretch;
}

@media screen and (min-width: 1024px) {
  .hub-home {
    margin-top: 24px !important;
    min-height: calc(100vh - 104px);
  }

  .hub-home__hero {
    margin: 0 0 24px;
    padding: 24px;
    border-radius: 12px;
  }

  .hub-home__grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }
}
</style>
